import {Box,TextField,InputAdornment,IconButton,Tooltip} from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import {DefaultConfig} from '../../../core/utilities/Utilities';
import {getEntityVideoUrl} from '../../integration/ObjectManager.js';
const readOnlyBackgroundColor=DefaultConfig.readOnlyBackgroundColor;

// Generic read-only "generated document" field - companion to FieldVideo.js,
// reusing the exact same <fieldName>_object_key/_filename/_mime_type/_size/
// _uploaded_at column convention and the same generic streaming route (named
// for video but format-agnostic - see get_entity_video_route in
// database_core/routes.py). Unlike FieldVideo, nothing is ever uploaded
// through this field - the file is written server-side (e.g.
// AnalysisRequest.report_pdf_* by publish_analysis_report()) - so there is no
// upload control here, only a download link once a file exists.
const FieldPdf=({row,fieldName,entityType,application})=>{
    const fieldProp=row?.[fieldName];
    const recordId=row?.id?.value;
    const docFieldPrefix=fieldName?.replace(/_filename$/,'')||'document';
    const filename=fieldProp?.value;

    const handleDownload=async()=>{
        if(!recordId||!filename) return;
        const url=await getEntityVideoUrl(entityType,recordId,docFieldPrefix);
        window.open(url,'_blank');
    };

    return (
        <Box sx={{flex:1,minWidth:0}}>
            <TextField
                style={{marginTop:"0px",marginBottom:"8px"}}
                sx={{input:{backgroundColor:readOnlyBackgroundColor}}}
                InputProps={{
                    readOnly:true,
                    endAdornment:filename&&(
                        <InputAdornment position="end">
                            <Tooltip title={application.getLocale('ButtonDownloadReportPdf')}>
                                <IconButton onClick={handleDownload} color="primary">
                                    <DownloadIcon/>
                                </IconButton>
                            </Tooltip>
                        </InputAdornment>
                    )
                }}
                id={fieldName}
                name={fieldName}
                fullWidth
                variant="outlined"
                size="small"
                label={fieldProp?.ui_label_locale?application.getLocale(fieldProp?.ui_label_locale):fieldName}
                value={filename?filename:application.getLocale('LabelReportNotGeneratedYet')}
                margin="normal"/>
        </Box>
    );
};

export default FieldPdf;
